import {
  PlanExtra,
  PlanExtraComposite,
  PlanExtraDetail
} from '@dtx-company/true-common/src/types/Plan'
import React from 'react'
/**
 * Composites planExtras and their details to get a planExtra with
 * a currentQuantity for the current user.
 *
 * Extras are sorted to ensure a consistent order.
 */
export function usePlanPurchaseExperienceExtraComposites(
  planExtras: PlanExtra[] | undefined,
  planExtraDetails: PlanExtraDetail[] | undefined
): PlanExtraComposite[] | undefined {
  return React.useMemo(() => {
    if (!planExtras || planExtras.length === 0) return
    return (
      planExtras
        .map(planExtra => {
          const currentDetail = planExtraDetails?.find(detail => {
            return detail.planExtraId === planExtra.planExtraId
          })

          return {
            ...planExtra,
            currentQuantity: currentDetail?.quantity || planExtra.minQuantity
          }
        })
        // Hide plan extras where the user cannot change the quantity
        .filter(planExtra => planExtra.minQuantity !== planExtra.maxQuantity)
        .sort((a, b) => -a.planExtraType.localeCompare(b.planExtraType))
    )
  }, [planExtraDetails, planExtras])
}
